{
  "title": "Steel Wind Strike",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "5th-level conjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "S, M (a melee weapon worth at least 1 sp)",
  "duration": "Instantaneous",
  "description": [
    "You flourish the weapon used in the casting and then vanish to strike like the wind. Choose up to five creatures you can see within range. Make a melee spell attack against each target. On a hit, a target takes 6d10 force damage.",
    "You can then teleport to an unoccupied space you can see within 5 feet of one of the targets you hit or missed."
  ],
  "spellLists": ["ranger", "wizard"]
}
